const inrFmt = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 })
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function inr (n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—'
  return '₹' + inrFmt.format(Math.round(Number(n)))
}

export function lakh (n) {
  const v = Number(n)
  if (!Number.isFinite(v)) return '—'
  return (Number.isInteger(v) ? v : v.toFixed(2)) + ' L'
}

export function fmtDate (iso) {
  if (!iso) return '—'
  const [y, m, d] = String(iso).slice(0, 10).split('-')
  if (!y || !m || !d) return String(iso)
  return `${d} ${MONTHS[Number(m) - 1]} ${y}`
}

export function fmtStamp (value) {
  if (!value) return '—'
  const dt = new Date(value)
  if (Number.isNaN(dt.getTime())) return String(value)
  const d = String(dt.getDate()).padStart(2, '0')
  const time = dt.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false })
  return `${d} ${MONTHS[dt.getMonth()]} ${dt.getFullYear()} · ${time}`
}

export const todayISO = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(new Date())

export function addDays (iso, n) {
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number)
  const dt = new Date(Date.UTC(y, m - 1, d))
  dt.setUTCDate(dt.getUTCDate() + n)
  return dt.toISOString().slice(0, 10)
}

export function diffDays (a, b) {
  const ms = Date.parse(String(b).slice(0, 10) + 'T00:00:00Z') - Date.parse(String(a).slice(0, 10) + 'T00:00:00Z')
  return Math.round(ms / 86400000)
}

// ------------------------------------------------------------------ statuses
export const ORDER_STATUS = {
  awaiting_advance: { label: 'Awaiting advance', tone: 'warn', hint: 'Seed is held informally. Capacity is blocked only once the advance lands.' },
  advance_verified: { label: 'Advance verified · batch blocked', tone: 'info', hint: 'Capacity blocked at the hatchery. The sample balloon must go out next.' },
  sample_dispatched: { label: 'Sample balloon dispatched', tone: 'info', hint: '100 animals sent by public transport. Farmer runs the 24-hour pond survival test.' },
  sample_passed: { label: 'Sample passed · awaiting balance', tone: 'good', hint: 'Survival cleared the threshold. Collect the balance before anything is packed.' },
  sample_failed: { label: 'Sample FAILED · re-match needed', tone: 'bad', hint: 'Survival below threshold. The farmer needs an alternative lot for the same stocking date.' },
  balance_verified: { label: 'Full payment verified', tone: 'good', hint: 'Funds in hand. Release the hatchery payout so they can start packing.' },
  payout_released: { label: 'Hatchery paid · cleared to pack', tone: 'good', hint: 'Hatcheries will not pack without full settlement. Assign a vehicle and liaison officer.' },
  trip_assigned: { label: 'Vehicle & liaison assigned', tone: 'info', hint: 'The liaison officer travels with the vehicle from the hatchery gate to the pond.' },
  packed: { label: 'Packed · gate pass issued', tone: 'info', hint: 'Bag count and water parameters logged at the hatchery.' },
  in_transit: { label: 'In transit to pond', tone: 'info', hint: 'Oxygenated bags on the road with the liaison officer.' },
  delivered: { label: 'Delivered at pond', tone: 'good', hint: 'Farmer OTP captured. Any transit mortality is logged for settlement.' },
  completed: { label: 'Completed', tone: 'good', hint: 'Order closed.' },
  cancelled: { label: 'Cancelled', tone: 'muted', hint: 'Order withdrawn.' }
}

export const ORDER_FLOW = [
  'awaiting_advance', 'advance_verified', 'sample_dispatched', 'sample_passed',
  'balance_verified', 'payout_released', 'trip_assigned', 'packed',
  'in_transit', 'delivered', 'completed'
]

export const statusLabel = s => ORDER_STATUS[s]?.label || s
export const statusTone = s => ORDER_STATUS[s]?.tone || 'muted'
export const statusHint = s => ORDER_STATUS[s]?.hint || ''

export const SHORT_STEP = {
  awaiting_advance: 'Advance',
  advance_verified: 'Blocked',
  sample_dispatched: 'Sample out',
  sample_passed: 'Sample OK',
  balance_verified: 'Paid',
  payout_released: 'Payout',
  trip_assigned: 'Vehicle',
  packed: 'Packed',
  in_transit: 'Transit',
  delivered: 'Delivered',
  completed: 'Closed'
}

export const BATCH_STATUS = {
  draft: { label: 'Draft', tone: 'muted' },
  active: { label: 'Open for booking', tone: 'good' },
  sample_stage: { label: 'Sampling', tone: 'info' },
  sold_out: { label: 'Sold out', tone: 'warn' },
  closed: { label: 'Closed', tone: 'muted' }
}

export const FLAG = {
  clear: { label: 'Clear', tone: 'good' },
  observation: { label: 'Under observation', tone: 'warn' },
  red_flag: { label: 'RED FLAG', tone: 'bad' }
}

export const OFFER_TYPES = [
  { value: 'none', label: 'No offer' },
  { value: 'volume_discount', label: 'Volume discount (% off)' },
  { value: 'flat_off', label: 'Flat ₹ off per 1,000 PL' },
  { value: 'bonus_seed', label: 'Bonus seed (% extra PL free)' },
  { value: 'early_bird', label: 'Early bird (% off, 10+ days ahead)' }
]

export const PL_STAGES = ['PL8', 'PL10', 'PL11', 'PL12', 'PL13', 'PL14', 'PL15', 'P. monodon PL15']

export const BROODSTOCK = [
  'Kona Bay (Hawaii)', 'SIS', 'Benchmark Genetics', 'Local multiplication centre', 'Other'
]

export const COURIER_MODES = [
  'APSRTC parcel service', 'Private bus parcel', 'Private courier', 'Hatchery vehicle', 'Farmer collected'
]
